var _interface = require('util/interface').interface;

/**
 * An ErrorReport from the server.
 *
 * @class ErrorReport
 * @property {String} message - The error message.
 * @property {Number} line - The line at which the problem was found.
 * @property {Number} column - The column at which the problem was found.
 */
var ErrorReport = _interface('ErrorReport', [
    /*
     * The error message
     */
    'message',

    /*
     * The line at which the problem was found
     */
    'line',

    /*
     * The column at which the problem was found
     */
    'column'
]);

module.exports = ErrorReport;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/error-report.js
// module id = 939
// module chunks = 1